module.exports = __webpack_public_path__ + "static/media/court.0ac25507.jpg";